// extracted by mini-css-extract-plugin
export default {"clientBlock":"PastClientBlockItem_clientBlock__xmYt5"};